import React from 'react'

import FormRowFormField from "./form-row/form-row-field"
import RequestForm from "../../model/request-form"
import FormManager from "../../../../../core/gd-form/common/form-manager"
import ButtonSubmit from "../../../../../core/gd-form/common/btn-submit/btn-submit-ui5-new"

type Props = {
    requestForm : RequestForm
    form        : FormManager
}

const debug = false
// const debug = "FromViewBody"

export default class FromViewBody extends React.Component<Props> {
    render() {
        debug && console.log(debug, "render", this.props.requestForm.settings.fields)

        return (
            <div className="form-body gd-request-form">
                {_.map(this.props.requestForm.settings.fields, (formField)=> {
                    if (!formField.field?.fieldId) return null
                    return <FormRowFormField key            = {formField.field?.fieldId}
                                             formField      = {formField}
                                             form           = {this.props.form}
                                             requestForm    = {this.props.requestForm}/>
                })}

                <div className="form-actions flex-row-center-center">
                    <ButtonSubmit className = "w-175 flex-row-center-center"
                                  form      = {this.props.form}
                                  label     = "Submit"/>
                </div>
            </div>
        )
    }
}
